var pointer = [
	[0,0],
	[0,0]
]
var dragTimer,
	moveTimer,
	smoothTimer;
var isDrag = false;
//クリックのポイントを取得するために、各ブロックの座標をメモ
var Recommend = {
	start: 0,
	end: 0,
	href: ""
}
var recommendBlocks = [];
//スクロール
var smoothScroll = {
	moveX: 0,
	currentPos: 0,
	movingPos: 0,
	endPoint: 0,
	listW: 0,
	distance: 0,
	init: function(){
	//	console.log("smooth Scroll init", isSmallScreen)
		let $list 		= $("#wrap_recommend"),
			$listlist 	= $(".list_recommend li"),
			$pointer 	= $("#pointer");
		var pos 	= 0,
			movepx 	= 0,
			r 		= recommendX;
		var s = smoothScroll;
		if($html.classList.contains("iPad")){ return false}
		if(isSmallScreen){ return false}
		clearInterval(moveTimer);
		$("#recommend").find("ul").css({
			"transform": "translate3d(0px,0,0)"
		});
		//
		if(!$("#wrap_recommend").length > 0){
			return false
		}
		moveTimer = setInterval(function(){
			let diff = s.movingPos - s.currentPos;
			
			s.currentPos += (s.movingPos - s.currentPos)*0.2;
			s.currentPos = clamp(s.currentPos, 0, s.listW);

			$("#recommend").find("ul").css({
				"transform": "translate3d(" + -s.currentPos + "px,0,0)"
			});

			let pDiffX = pointer[0][1] - pointer[0][0],
				pDiffY = pointer[1][1] - pointer[1][0];
			if(pDiffX > 0){
				pointer[0][0] += ( pointer[0][1] - pointer[0][0] )*0.1;
				pointer[1][0] += ( pointer[1][1] - pointer[1][0] )*0.1;
			}else{
				pointer[0][0] -= ( pointer[0][0] - pointer[0][1] )*0.1;
				pointer[1][0] -= ( pointer[1][0] - pointer[1][1] )*0.1;
			}
			$pointer.css({
				"left": pointer[0][0] + "px",
				"top": pointer[1][0] + "px"
			});
		}, 33);
		
		if(!isSmallScreen || !$html.classList.contains("iPad")){
			$("#recommend_product").off().on({
				"mouseenter": function(){
					if(!$pointer.hasClass("active")){
						$pointer.addClass("active");
					}
				},
				"mouseleave": function(){
					if($pointer.hasClass("active")){
						$pointer.removeClass("active");
					}
				}
			});
		}
		
		var $recommend = document.getElementById("wrap_recommend"),
			dragging = false;
		var tickTimer = null;

		//clickのcallback
		var tickCallBack = function(point) {
			setTimeout(function(){
				if(!isDrag){
					var clickPoint = Math.floor( s.currentPos + point );
				//	console.log(clickPoint);
					recommendBlocks.some(function(val, index){
						var b = val;
						if(clickPoint >= b.start && clickPoint < b.end){
							page.changeURL(b.href);
							document.activeElement.blur();
							return true;
						}
					});
					tickTimer = null;
				}else{
					return false
				}
			},300);
		};

		$recommend.addEventListener("mousedown", function(e){ 
			var len 	= $(".list_recommend li").length,
				_w 		= $(".list_recommend li").width(),
				winW 	= $(window).width();
			smoothScroll.listW 	= len*(_w +40) - $(window).width() + winW*0.0439;
			pos 		= mouse[0];
			dragging 	= true;
			var point	= e.clientX;

			if(tickTimer) {
				clearTimeout(tickTimer);
			}
			tickTimer = setTimeout(function(){
				tickCallBack(point);
			}, 100);

			dragTimer = setTimeout(function(){
				$list.addClass("drag");
				$pointer.addClass("drag");
				isDrag 		= true;
			}, 300);
		});
		$recommend.addEventListener("mousemove", function(e){
			smoothScroll.move(pos);
		});
		$recommend.addEventListener("mouseup", function(e){
			up();
		});
		$recommend.addEventListener("mouseleave", function(e){
			up();
		});

		function up(){
			clearTimeout(dragTimer);
			$list.removeClass("drag");
			$pointer.removeClass("drag");
			$("#wrap_recommend").removeClass("hover");
			isDrag = false;
		}
	},
	move: function(start){
		var s = smoothScroll;
		if(isDrag){
			var diff 	= start - mouse[0]
			s.moveX 	+= (diff - s.distance);
			s.distance 	= diff;
			s.endPoint 	= Math.abs( s.distance );	//mouseのゴール
			
			s.movingPos = s.currentPos + s.moveX;
		}
	}
}